<template>
    <div class="menu-button-container">
        <button
            class="draggable-item-menu-btn draggable-item-menu-btn-blue draggable-item-menu-btn-pause" @click="openModal">
            Pausar
        </button>
        <transition name="slide-fade">
            <PauseOrderReferenceButtonActionModal
                v-if="showModal"
                :orderReference="orderReference"
                :endOfAction="endOfAction"
                :closeModal="closeModal"
            />
        </transition>
    </div>
</template>

<script>
import PauseOrderReferenceButtonActionModal from './PauseOrderReferenceButtonActionModal.vue';
export default {
    name: "PauseOrderReferenceButton",
    components: {
        PauseOrderReferenceButtonActionModal,
    },
    props: {
        orderReference: {
            type: Object,
            required: true
        },
        endOfAction: {
            type: Function,
            required: true
        },
    },
    data() {
        return {
            producedQuantity: 0,
            showModal: false,
        };
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
    },
};
</script>